import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { RoundFilledIcon } from '../RoundFilledIcon/RoundFilledIcon';

export const IconModeDesktop = styled(RoundFilledIcon).attrs({ size: 'lg' })``;
export const IconModeMobile = styled(Icon).attrs({ size: 'md' })``;
export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        ${IconModeDesktop} { display: none; }
        ${IconModeMobile} { display: flex; }
    `}
    ${purpurMedia('lg')`
        ${IconModeDesktop} { display: flex; }
        ${IconModeMobile} { display: none; }
    `}
`;
